// extracted by mini-css-extract-plugin
export default {"signup-image-container":"onboardingImage_signup-image-container__l16gC"};